import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import * as _ from "lodash";

interface IState {
    fileprop: any
    filevalue: string
    rawdata: Array<{ id: string, value: string }>
    data: Array<{ id: string, value: string }>
    pages: any
    sorted: Array<any>
    filtered: Array<any>
    resetdata: boolean
    add: {
        kata: string
        lema: string
        prefiks: string
        infiks: string
        konfiks: string
        ulang: string
        majemuk: string
    }
    edit: any
    saving: boolean
    loading: boolean
    tab: string
}

export default class Tabulasi extends React.Component<any, IState> {
    private url: any;

    constructor(props: any) {
        super(props);
        this.state = {
            fileprop: "",
            filevalue: "",
            rawdata: [],
            data: [],
            sorted: [],
            filtered: [],
            resetdata: true,
            add: { kata: "", lema: "", prefiks: "", infiks: "", konfiks: "", ulang: "", majemuk: "" },
            edit: {},
            pages: null,
            saving: false,
            loading: false,
            tab: "add"
        }
        this.fetchData = this.fetchData.bind(this);
    }

    componentWillMount() {
        this.url = window.location.origin;
        if (window.location.port === "8080") {
            this.url = this.url.replace("8080", "3000");
        } else if(window.location.port === "") {
            this.url = this.url + ":1000";
        }
    }

    getTabulasi() {
        return new Promise(resolve => {
            if (this.state.rawdata.length > 0 && !this.state.resetdata) resolve(this.state.rawdata);

            const self = this;
            $.ajax({
                type: "POST",
                url: this.url + "/api/db/queryAll",
                data: { sql: "SELECT * FROM tabulasi ORDER BY id DESC" },
                dataType: "JSON"
            }).done(function (res: any) {
                if (res.status === "error") {
                    console.error(res);
                    alert("Error !!!")
                } else {
                    if (res.msg === null) res.msg = [];
                    self.setState({ rawdata: res.msg, resetdata: false })
                    resolve(res.msg);
                }
            }).fail(function (res: any) {
                console.error(res);
                alert("Failed");
            });
        });
    }

    requestData(pageSize: any, page: any, sorted: any, filtered: any) {
        return new Promise((resolve, reject) => {
            this.getTabulasi().then((filteredData: any) => {
                // You can use the filters in your request, but you are responsible for applying them.
                if (filtered.length) {
                    filteredData = filtered.reduce((filteredSoFar: any, nextFilter: any) => {
                        return filteredSoFar.filter((row: any) => {
                            return (row[nextFilter.id].toLowerCase() + "").includes(nextFilter.value.toLowerCase());
                        });
                    }, filteredData);
                }
                // You can also use the sorting in your request, but again, you are responsible for applying it.
                const sortedData = _.orderBy(
                    filteredData,
                    sorted.map((sort: any) => {
                        return (row: any) => {
                            if (row[sort.id] === null || row[sort.id] === undefined) {
                                return -Infinity;
                            }
                            return typeof row[sort.id] === "string"
                                ? row[sort.id].toLowerCase()
                                : row[sort.id];
                        };
                    }),
                    sorted.map((d: any) => (d.desc ? "desc" : "asc"))
                );

                // You must return an object containing the rows of the current page, and optionally the total pages number.
                const res = {
                    rows: sortedData.slice(pageSize * page, pageSize * page + pageSize),
                    pages: Math.ceil(filteredData.length / pageSize)
                };

                // Here we'll simulate a server response with 500ms of delay.
                setTimeout(() => resolve(res), 500);
            })
        });
    };

    fetchData(state: any, instance: any = null) {
        // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        this.setState({ loading: true });
        // Request the data however you want.  Here, we'll use our mocked service we created earlier
        this.requestData(
            state.pageSize,
            state.page,
            state.sorted,
            state.filtered
        ).then((res: any) => {
            // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
            this.setState({
                data: res.rows,
                pages: res.pages,
                loading: false
            });
        });
    }

    resetData() {
        this.setState({
            sorted: [],
            filtered: []
        });
    }

    changeTab(tab: string) {
        this.setState({ tab: tab });
    }

    handleChange(e: any) {
        const file = e.target.files[0];
        let fileprop: string = "";
        let filevalue: string = "";
        if (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            fileprop = file;
            filevalue = e.target.value
        } else {
            alert("Format file not allowed !!!");
        }
        this.setState({ fileprop: fileprop, filevalue: filevalue });
    }

    handleChangeAdd(e: any) {
        let add = this.state.add;
        add[e.target.name] = e.target.value;
        this.setState({ add })
    }

    handleChangeEdit(e: any) {

        let add = this.state.add;
        add[e.target.name] = e.target.value;
        this.setState({ add })
    }

    hanldeCreate() {
        this.setState({ saving: true });

        const add = this.state.add;
        const self = this;

        $.ajax({
            type: "POST",
            url: this.url + "/api/db/insert",
            data: { table: "tabulasi", data: JSON.stringify(add) },
            dataType: "JSON"
        }).done(function (res: any) {
            if (res.status === "error") {
                console.error(res);
                alert("Error !!!");
            } else {
                alert("Success !!!");
            }
            self.setState({ saving: false, resetdata: true, add: { kata: "", lema: "", prefiks: "", infiks: "", konfiks: "", ulang: "", majemuk: "" } }, () => self.resetData());
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed !!!");
            self.setState({ saving: false, add: { kata: "", lema: "", prefiks: "", infiks: "", konfiks: "", ulang: "", majemuk: "" } });
        });
    }

    handleUpdateMultiple() {
        if (!confirm("Klik ok untuk melanjutkan")) return
        this.setState({ saving: true });

        const edit = this.state.edit;
        const self = this;

        let data: any = [];
        let params: any = [];

        Object.keys(edit).forEach(k => {
            data.push(edit[k].new)
            params.push({ id: edit[k].new.id })
        })

        $.ajax({
            type: "POST",
            url: this.url + "/api/db/updatebatch",
            data: { table: "tabulasi", data: JSON.stringify(data), params: JSON.stringify(params) },
            dataType: "JSON"
        }).done(function (res: any) {
            if (res.status === "error") {
                console.error(res);
                alert("Error !!!");
            } else {
                alert("Success !!!");
            }
            self.setState({ saving: false, resetdata: true, edit: {} }, () => self.resetData());
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed !!!");
            self.setState({ saving: false });
        });
    }

    handleDelete(id: string) {
        if (!confirm("Klik ok untuk melanjutkan")) return
        this.setState({ saving: true });

        const self = this;

        $.ajax({
            type: "POST",
            url: this.url + "/api/db/delete",
            data: { table: "tabulasi", params: JSON.stringify({ id: id }) },
            dataType: "JSON"
        }).done(function (res: any) {
            if (res.status === "error") {
                // alert(res.msg.err);
                console.error(res);
                alert("Error !!!");
            } else {
                alert("Seccess !!!");
            }
            self.setState({ saving: false, resetdata: true }, () => self.resetData());
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed !!!");
            self.setState({ saving: false });
        });
    }

    import() {
        if (!confirm("Klik ok untuk melanjutkan")) return
        this.setState({ saving: true });
        let data = new FormData();
        data.append('file', this.state.fileprop);

        const self = this;
        $.ajax({
            type: "POST",
            url: this.url + "/api/import/tabulasi",
            data: data,
            dataType: "JSON",
            processData: false,
            contentType: false
        }).done(function (res: any) {
            if (res.status === "error") {
                console.error(res);
                alert("Error !!!");
                // alert(res.msg.err);
            } else {
                alert("Success !!!");
            }
            self.setState({ saving: false, resetdata: true, fileprop: "", filevalue: "" }, () => self.resetData());
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed !!!");
            self.setState({ saving: false, fileprop: "", filevalue: "" });
        });
    }

    download() {
        const self = this;
        $.ajax({
            type: "POST",
            url: this.url + "/api/export/tabulasi",
            data: {},
            dataType: "JSON",
            processData: false,
            contentType: false
        }).done(function (res: any) {
            if (res.status === "error") {
                console.error(res);
                alert("Error !!!");
            } else {
                location.href = self.url + '/download/' + res.msg.filename
            }
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed !!!");
        });
    }

    renderEditable(cellInfo: any) {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    if (cellInfo.value !== e.target.innerHTML) {
                        const data = [...this.state.data];
                        const row = cellInfo.row;
                        let edit = this.state.edit;

                        if (edit[row.id] === undefined) {
                            const old = { id: row.id, ...row };
                            edit[row.id] = { new: row._original, old }
                        } else {
                            edit[row.id].new = row._original;
                        }

                        data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                        this.setState({ data, edit });
                    }
                }}
                dangerouslySetInnerHTML={{
                    __html: this.state.data[cellInfo.index][cellInfo.column.id]
                }}
            />
        );
    }

    renderActionable(cellInfo: any) {
        const row = cellInfo.row;
        let edit = this.state.edit;
        return (
            <div style={{ textAlign: "center" }}>
                {edit[row.id] !== undefined && <div>
                    <a onClick={() => {
                        let data = this.state.data;
                        data[cellInfo.index] = edit[row.id].old;
                        delete edit[row.id];
                        this.setState({ data, edit })
                    }} className='btn btn-sm btn-default'><i className="icon icon-refresh"></i></a>
                </div>}

                {edit[row.id] === undefined && <div>
                    <a onClick={() => this.handleDelete(cellInfo.value)} className='btn btn-sm btn-error'><i className="icon icon-delete"></i></a>
                </div>}
            </div>
        );
    }

    render() {
        const columns = [
            {
                Header: '#',
                Cell: (props: any) => <div style={{ textAlign: "center" }}>{props.index + 1}</div>,
                width: 100
            }, {
                Header: 'Kata',
                accessor: 'kata', // String-based value accessors!
                Cell: (props: any) => this.renderEditable(props)
            }, {
                Header: 'Lema',
                accessor: 'lema', // String-based value accessors!
                Cell: (props: any) => this.renderEditable(props)
            }, {
                Header: 'Prefiks',
                accessor: 'prefiks', // String-based value accessors!
                Cell: (props: any) => this.renderEditable(props)
            }, {
                Header: 'Infiks',
                accessor: 'infiks', // String-based value accessors!
                Cell: (props: any) => this.renderEditable(props)
            }, {
                Header: 'Konfiks',
                accessor: 'konfiks', // String-based value accessors!
                Cell: (props: any) => this.renderEditable(props)
            }, {
                Header: 'Ulang',
                accessor: 'ulang', // String-based value accessors!
                Cell: (props: any) => this.renderEditable(props)
            }, {
                Header: 'Majemuk',
                accessor: 'majemuk', // String-based value accessors!
                Cell: (props: any) => this.renderEditable(props)
            }, {
                Header: 'Action',
                accessor: 'id',
                Cell: (props: any) => this.renderActionable(props),
                width: 100
            }]

        return <div style={{ padding: 25 }}>
            <div className="columns">
                <div className="column col-4">
                    <div className="panel">
                        <div className="panel-header" style={{ borderBottom: "1px solid #e7e9ec" }}>
                            <div className="panel-title"><b>Manage Tabulasi</b></div>
                        </div>
                        {/* tab nav */}
                        <div className="panel-nav" style={{ padding: "0 10px 10px 10px" }}>
                            <ul className="tab tab-block">
                                <li className={`tab-item ${this.state.tab === "add" ? "active" : ""}`}>
                                    <a href="#" onClick={() => this.changeTab("add")}>Add</a>
                                </li>
                                <li className={`tab-item ${this.state.tab === "import_download" ? "active" : ""}`}>
                                    <a href="#" onClick={() => this.changeTab("import_download")}>Import &amp; Download</a>
                                </li>
                            </ul>
                        </div>
                        {/* tab add */}
                        {this.state.tab === "add" && <div>
                            <div className="panel-body">
                                <div className="card-body">
                                    <form className="form-horizontal">
                                        <div className="form-group">
                                            <div className="col-3 col-sm-12">
                                                <label className="form-label">Kata</label>
                                            </div>
                                            <div className="col-9 col-sm-12">
                                                <input className="form-input" type="text" name="kata" onChange={(e) => this.handleChangeAdd(e)} value={this.state.add.kata} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-3 col-sm-12">
                                                <label className="form-label">Lema</label>
                                            </div>
                                            <div className="col-9 col-sm-12">
                                                <input className="form-input" type="text" name="lema" onChange={(e) => this.handleChangeAdd(e)} value={this.state.add.lema} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-3 col-sm-12">
                                                <label className="form-label">Prefiks</label>
                                            </div>
                                            <div className="col-9 col-sm-12">
                                                <input className="form-input" type="text" name="prefiks" onChange={(e) => this.handleChangeAdd(e)} value={this.state.add.prefiks} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-3 col-sm-12">
                                                <label className="form-label">Infiks</label>
                                            </div>
                                            <div className="col-9 col-sm-12">
                                                <input className="form-input" type="text" name="infiks" onChange={(e) => this.handleChangeAdd(e)} value={this.state.add.infiks} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-3 col-sm-12">
                                                <label className="form-label">Konfiks</label>
                                            </div>
                                            <div className="col-9 col-sm-12">
                                                <input className="form-input" type="text" name="konfiks" onChange={(e) => this.handleChangeAdd(e)} value={this.state.add.konfiks} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-3 col-sm-12">
                                                <label className="form-label">Ulang</label>
                                            </div>
                                            <div className="col-9 col-sm-12">
                                                <input className="form-input" type="text" name="ulang" onChange={(e) => this.handleChangeAdd(e)} value={this.state.add.ulang} />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-3 col-sm-12">
                                                <label className="form-label">Majemuk</label>
                                            </div>
                                            <div className="col-9 col-sm-12">
                                                <input className="form-input" type="text" name="majemuk" onChange={(e) => this.handleChangeAdd(e)} value={this.state.add.majemuk} />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="panel-footer" style={{ textAlign: "right" }}>
                                {!this.state.saving && <button className="btn btn-success" onClick={() => this.hanldeCreate()}><i className="icon icon-check"></i> Save</button>}
                                {this.state.saving && <div className="loading"></div>}
                            </div>
                        </div>}

                        {/* tab import & download */}
                        {this.state.tab === "import_download" && <div>
                            <div className="panel-body">
                                <div className="card-body">
                                    <input type="file" value={this.state.filevalue} className="form-input" onChange={(e) => this.handleChange(e)}
                                        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                                    <small>Format file: xls,xlsx</small>
                                </div>
                            </div>
                            <div className="panel-footer" style={{ textAlign: "right" }}>
                                {!this.state.saving && <button className="btn btn-default" onClick={() => this.import()} disabled={this.state.filevalue === ""}><i className="icon icon-upload"></i> Import</button>}&nbsp;&nbsp;
                                {!this.state.saving && <button className="btn btn-success" onClick={() => this.download()}><i className="icon icon-download"></i> Download</button>}
                                {this.state.saving && <div className="loading"></div>}
                            </div>
                        </div>}
                    </div>
                </div>
                <div className="column col-8">
                    <div style={{ textAlign: "right", marginBottom: 10 }}>
                        <button className="btn btn-default" disabled={Object.keys(this.state.edit).length === 0} onClick={() => this.setState({ edit: {}, resetdata: true }, () => this.resetData())}><i className="icon icon-refresh"></i> Reset</button>&nbsp;&nbsp;
                        <button className="btn btn-success" disabled={Object.keys(this.state.edit).length === 0} onClick={() => this.handleUpdateMultiple()}><i className="icon icon-check"></i> Save</button>
                    </div>
                    <div>
                        <ReactTable
                            manual={true}
                            data={this.state.data}
                            columns={columns}
                            // Controlled props
                            sorted={this.state.sorted}
                            filtered={this.state.filtered}

                            // 
                            onSortedChange={sorted => this.setState({ sorted })}
                            onFilteredChange={filtered => this.setState({ filtered })}

                            pages={this.state.pages}
                            defaultPageSize={10}
                            filterable={true}
                            className="-striped -highlight"
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                        />
                    </div>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/admin/Tabulasi.tsx